import { makeBanner } from "../models/banner.model";

class MarketingApiService {
  constructor(HttpService, SessionService) {
    'ngInject';

    this.HttpService = HttpService;
    this.SessionService = SessionService;
  }

  generate(payload) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/marketing/generate-banner', payload);
  }

  getBannerList() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/marketing/list-banner').then(banners => {
      return banners.map(banner => makeBanner(banner));
    });
  }

  getReferralLinks() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/marketing/referral-links');
  }

  confirm() {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/marketing/confirm');
  }

  getImagesList() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/marketing/images-list');
  }

  previewBanner(fileName) {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/marketing/view-banner/' + fileName, 'arraybuffer')
    .then((response) => {
      return this.toBase64(response);
    });
  }

  toBase64(buffer) {
    let binary = '';
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
  }
}

export default MarketingApiService;



// WEBPACK FOOTER //
// ./client/app/api/services/marketing.api.service.js